<template>
  <div class="history-download">
    <!-- 顶部操作栏 -->
    <div class="operation-bar">
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="6">
          <el-input
            v-model="searchForm.resource_title"
            placeholder="请输入资源标题"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="searchForm.user_name"
            placeholder="请输入用户名"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>

    <!-- 下载历史列表 -->
    <div class="table-container">
      <el-table :data="downloadList" style="width: 100%" v-loading="loading">
        <el-table-column prop="resource_title" label="资源标题"></el-table-column>
        <el-table-column prop="user_name" label="用户名" width="120"></el-table-column>
        <el-table-column prop="download_time" label="下载时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.download_time) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="download_status" label="下载状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.download_status ? 'success' : 'danger'">
              {{ scope.row.download_status ? "成功" : "失败" }}
            </el-tag>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mqHistoryDownload } from "../api/index";

export default {
  name: "MqHistoryDownload",
  data() {
    return {
      loading: false,
      downloadList: [],
      searchForm: {
        user_name: "",
        resource_title: "",
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    this.fetchDownloadList();
  },
  methods: {
    // 获取下载历史列表
    async fetchDownloadList() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.searchForm,
        };
        const res = await mqHistoryDownload(params);
        this.downloadList = res.data.data;
        this.pagination.total = res.data.pagination.total;
      } catch (error) {
        console.error(error);
        this.$message.error("获取下载历史失败");
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchDownloadList();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchDownloadList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchDownloadList();
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(
        d.getMinutes()
      ).padStart(2, "0")}:${String(d.getSeconds()).padStart(2, "0")}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.history-download {
  padding: 20px;

  .operation-bar {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .table-container {
    background-color: #fff;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
